import React, { Component } from "react";
import { Link } from "react-router-dom";
import StarRatingComponent from "react-star-rating-component";

export default class CourseList extends Component {
  state = {
    courses: [
      {
        id: "1",
        name: "Math",
        teacher: "James stunner",
        time: "",
        fav: true,
        rating: 1,
        image:
          "https://images.pexels.com/photos/1619844/pexels-photo-1619844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "2",
        name: "Chemistry",
        teacher: "Gary smith",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/2280549/pexels-photo-2280549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "3",
        name: "Biology",
        teacher: "Lina james",
        time: "",
        fav: true,
        rating: 1,
        image:
          "https://images.pexels.com/photos/753271/pexels-photo-753271.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      },
      {
        id: "4",
        name: "Technology",
        teacher: "Chris steve",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/825258/pexels-photo-825258.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "5",
        name: "Chemistry",
        teacher: "Gary smith",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/2280549/pexels-photo-2280549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "6",
        name: "Technology",
        teacher: "Chris steve",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/825258/pexels-photo-825258.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "7",
        name: "Math",
        teacher: "James stunner",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/1619844/pexels-photo-1619844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "8",
        name: "Biology",
        teacher: "Lina james",
        time: "",
        fav: false,
        rating: 4,
        image:
          "https://images.pexels.com/photos/753271/pexels-photo-753271.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      },
    ],
  };

  fav = (e) => {
    var course = e.target.parentElement.parentElement.id;

    var courses = this.state.courses;

    for (let i = 0; i < courses.length; i++) {
      if (courses[i].id === course) {
        if (courses[i].fav) {
          courses[i].fav = false;
        } else {
          courses[i].fav = true;
        }
      }
    }
    this.setState({ courses: courses });
  };
  render() {
    return (
      <div>
        <div className="container pt-3">
          <div className="mt-4 mb-3">
            <h4>All Courses</h4>
          </div>
          <div class="row" id="filter">
            <div class="form-group col-sm-3 col-xs-6">
              <select
                data-filter="make"
                class="filter-make filter form-control"
              >
                <option value="">Courses</option>
                <option value="">Show All</option>
              </select>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <select
                data-filter="model"
                class="filter-model filter form-control"
              >
                <option value="">Subjects</option>
                <option value="">Show All</option>
              </select>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              {/* <select data-filter="type" class="filter-type filter form-control">
              <option value="">Topics</option>
              <option value="">Show All</option>
            </select> */}
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <div class="input-group search-box">
                <input
                  type="text"
                  id="search"
                  class="form-control"
                  placeholder="Search here"
                />
                <span class="input-group-addon">
                  <i class="material-icons">&#xE8B6;</i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr className="m-0 mt-2 mb-3" />
        <div className="container">
          <div className="row">
            {this.state.courses.map((course) => {
              return (
                <div className="col-md-3 my-3" id={course.id}>
                  <Link to="/course" className="link-unstyled">
                    <div
                      className="card card-selector shadow-sm mt-1"
                      onClick={this.cardSelect}
                    >
                      <img
                        class="card-img-top course-image"
                        src={course.image}
                        alt="Course Card image"
                      />
                      <div class="card-body">
                        <h5 className="mb-0">{course.name}</h5>

                        <p class="card-text pt-2">
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry.
                        </p>
                        <StarRatingComponent
                          name="rate1"
                          value={course.rating}
                        />
                        <Link
                          to="/quiz"
                          href="#"
                          class="btn btn-primary pull-right float-right"
                        >
                          Subscribe
                        </Link>
                      </div>
                    </div>
                  </Link>
                  <div className="favorite-course shadow-sm">
                    {course.fav ? (
                      <i class="fas fa-heart" onClick={this.fav} />
                    ) : (
                      <i class="far fa-heart" onClick={this.fav} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
